module.exports = __webpack_public_path__ + "img/limit.ae62cf61.svg";